<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <div class="tools"
                   style="width: calc(100% - 80px); margin: 0 40px 10px 40px; border-bottom: 1px #eee solid; padding-bottom: 10px">
                <el-select v-model="search.year"
                           placeholder="请选择年份"
                           size="small"
                           style="width:20%"
                           clearable>
                  <el-option v-for="(item,index) in yearList"
                             :key="index"
                             :label="item"
                             :value="item"></el-option>
                </el-select>
                <el-select v-model="search.cat_id"
                           placeholder="请选择项目"
                           size="small"
                           style="width:20%"
                           clearable>
                  <el-option v-for="(item,index) in projectList"
                             :key="index"
                             :label="item.cat_name"
                             :value="item.cat_id"></el-option>
                </el-select>
                <el-select v-model="search.eye_disease"
                           placeholder="请选择眼疾"
                           size="small"
                           style="width:20%"
                           clearable>
                  <el-option v-for="(item,index) in eyeDisease"
                             :key="index"
                             :label="item.text"
                             :value="item.value"></el-option>
                </el-select>
                <el-select v-model="search.haspics"
                           placeholder="请选择是否有其它证明"
                           size="small"
                           style="width:22%"
                           clearable>
                  <el-option label="有"
                             :value="1"></el-option>
                  <el-option label="无"
                             :value="2"></el-option>
                </el-select>

                <el-button type="primary"
                           size="small"
                           icon="el-icon-search"
                           @click="init(search)">搜索</el-button>
              </div>
              <el-button size="small"
                         style="margin:0px 10px 10px 40px;"
                         type="primary"
                         @click="imports">导入</el-button>
              <el-button size="small"
                         style="margin:0px 5px 10px 0;"
                         type="primary"
                         :disabled="disabled"
                         @click="modal = true">批量上传其它证明</el-button>
              <el-table :data="tableData"
                        ref="table"
                        border
                        size="small"
                        style="width: calc(100% - 80px); margin: 0 40px 40px 40px"
                        @selection-change="handleSelectionChange">
                <el-table-column type="selection"
                                 width="55"
                                 header-align="center"
                                 align="center"
                                 :selectable="disabledCheck"></el-table-column>

                <el-table-column label="姓名"
                                 prop="name"
                                 header-align="center"
                                 min-width="80"
                                 align="center"></el-table-column>

                <el-table-column label="身份证"
                                 prop="cardno"
                                 header-align="center"
                                 min-width="150"></el-table-column>

                <el-table-column label="眼疾"
                                 prop="eye_disease"
                                 header-align="center"
                                 align="center"
                                 min-width="70"></el-table-column>

                <el-table-column label="项目名称"
                                 prop="cat_name"
                                 header-align="center"
                                 min-width="100"
                                 align="center"></el-table-column>

                <el-table-column label="其它证明"
                                 prop="haspics"
                                 header-align="center"
                                 min-width="80"
                                 align="center"></el-table-column>

                <el-table-column label="上报状态"
                                 prop="status"
                                 header-align="center"
                                 min-width="100"
                                 align="center"></el-table-column>

                <el-table-column label="操作"
                                 prop="handle"
                                 header-align="center"
                                 min-width="180"
                                 align="center">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button @click="edit(scope.row.id)"
                                 type="primary"
                                 icon="el-icon-edit"
                                 size="mini">编辑</el-button>
                      <el-button @click="del(scope.row.id)"
                                 type="danger"
                                 icon="el-icon-delete"
                                 size="mini">删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination style="margin-bottom: 20px;margin-right: 30px;float:right"
                             background
                             layout="prev, pager, next"
                             :page-size="page_size"
                             @current-change="changePage"
                             :total="total"></el-pagination>
            </div>
          </el-col>
        </el-row>
        <el-dialog :visible.sync="modal"
                   title="批量上传其它证明"
                   center
                   width="700px"
                   @close="close">
          <span class="tishi">*将覆盖之前上传的其它证明</span>
          <el-upload ref="imgUploads"
                     :action="uploadImgUrl"
                     list-type="picture-card"
                     :data="uploadParms"
                     :on-preview="handlePictureCardPreview"
                     :on-success="onSuccess"
                     :on-remove="onRemove"
                     name="img"
                     :before-upload="beforeUpload">
            <i class="el-icon-plus"></i>
          </el-upload>
          <span slot="footer"
                class="dialog-footer">
            <el-button @click="modal = false">取 消</el-button>
            <el-button type="primary"
                       @click="submit">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="提示"
                   :visible.sync="dialogVisible"
                   width="30%">
          <span>删除后将无法恢复，确认删除吗？</span>
          <span slot="footer"
                class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="onDel">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <el-dialog :visible.sync="modalImg1"
                 title="发票样板">
        <img src="../../../assets/images/fpyb.jpg"
             alt
             style="width:100%" />
      </el-dialog>
      <el-dialog :visible.sync="modalImg2"
                 title="费用清单样板">
        <img src="../../../assets/images/fyqd.jpg"
             alt
             style="width:100%" />
      </el-dialog>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import "@/components/Hospital/public/poster.less";
import Axios from "axios";
import myHead from "@/components/Hospital/public/head";
import centerHead from "@/components/Hospital/public/center_head";
import leftMenu from "@/components/Hospital/public/menu";
import footDiv from "@/components/Hospital/public/foot";
export default {
  name: "report",
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data () {
    return {
      disabled: true, // 禁用按钮
      search: {}, // 搜索条件
      projectList: [], // 项目列表
      tableData: [], // 表格数据
      page_size: 15, // 每页条数
      total: 0, // 数据总条数
      currentPage: 1, // 当前页
      uploadImgUrl: "", // 上传到图片的地址
      modal: false, // 批量导入证明弹窗
      uploadParms: { file_type: 2 }, //图片上传所需参数
      uploadImgParams: { other_pics: [] }, // 保存凭证的参数
      yearList: [], // 年份
      eyeDisease: [], // 眼疾
      modal1: false, // 上传图片资料弹窗
      uploadPicParams: { cardno_pics: [], poor_pics: [], settlement_pics: [] },
      modalImg1: false, // 样板弹窗控制
      modalImg2: false, // 样板弹窗控制
      dialogVisible: false, // 删除确认框
      delId: null
    };
  },
  methods: {
    imports () {
      // 导入
      this.$router.push({ name: "reportExports" });
    },
    edit (id) {
      // 编辑
      this.$router.push({ name: "reportEdit", params: { id } });
    },
    handleSelectionChange (selection) {
      //
      let arr = [];
      if (selection.length > 0) {
        this.disabled = false;
        selection.forEach(item => {
          arr.push(item.id);
        });
      } else {
        this.disabled = true;
      }
      this.uploadImgParams.ids = arr.join(",");
    },
    init (search = {}) {
      let init = {};
      init.page_size = this.page_size;
      init.page = this.currentPage;
      Object.assign(init, search);
      this.$db.post("report-getReportApplyList", init).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    changePage (page) {
      // 当前页改变
      this.currentPage = page;
      this.init();
    },
    getEasyList () {
      // 获取简单列表
      this.$db.post("report-getReportCategoryList", {}).then(res => {
        this.projectList = res.data.cat;
        this.yearList = res.data.year;
      });
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100170,
          table: "pub_type_param"
        })
        .then(res => {
          this.eyeDisease = res.data;
        });
    },
    beforeUpload (file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },
    onSuccess (res, file, fileList) {
      // 上传成功图片成功的的回调
      let index1 = fileList.length - 1; // 记录数组位置
      if (this.uploadImgParams.other_pics.length > 0) {
        this.uploadImgParams.other_pics.some((item, index) => {
          if (
            this.uploadImgParams.other_pics[index] ==
            fileList[index1].response.data.id
          ) {
            fileList = fileList.pop(); // 删除最后一个元素
            this.$message.error("请不要上传相同文件");
            return true; // 终止循环
          }
        });
        if (fileList[index1]) {
          this.uploadImgParams.other_pics.push(
            fileList[index1].response.data.id
          );
        }
      } else {
        this.uploadImgParams.other_pics.push(fileList[index1].response.data.id);
      }
    },
    handlePictureCardPreview () {
      // 点击图片列表
    },
    onRemove (file, fileList) {
      let arr = [];
      fileList.forEach(item => {
        arr.push(item.response.data.id);
      });
      this.uploadImgParams.other_pics = arr;
    },
    submit () {
      // 保存图片上传
      this.$db
        .post("report-uploadOtherPicture", this.uploadImgParams)
        .then(res => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              type: "success",
              message: res.msg
            });
            this.$refs.table.clearSelection(); // 清空选中项
            this.uploadImgParams = { other_pics: [] }; // 保存成功则清空已选择的图片和勾选的用户id
            this.init(); // 刷新页面
            this.modal = false; // 关闭弹窗
            this.$refs.imgUploads.clearFiles(); // 清空已上传文件列表
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.msg
            });
          }
        });
    },
    close () {
      this.modal = false;
      this.$refs.table.clearSelection(); // 清空选中项
      this.uploadImgParams = { other_pics: [] }; // 取消则清空已选择的图片和勾选的用户id
      this.$refs.imgUploads.clearFiles(); // 清空已上传文件列表
    },
    close1 () {
      this.modal1 = false;
      this.uploadPicParams = {
        cardno_pics: [],
        poor_pics: [],
        settlement_pics: []
      }; // 清空已选择的图片
      this.$refs.imgUploadPic1.clearFiles();
      this.$refs.imgUploadPic2.clearFiles();
      this.$refs.imgUploadPic3.clearFiles(); // 清空已上传文件列表
    },
    disabledCheck (row, index) {
      if (row.status == "已上报") {
        return false;
      } else {
        return true;
      }
    },
    del (id) {
      this.delId = id;
      this.dialogVisible = true;
    },
    onDel () {
      this.$db.post("report-delReportApply", { id: this.delId }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.delId = null;
          this.init(); // 刷新表格
          this.dialogVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    submitUploadPic () {
      if (this.uploadPicParams.cardno_pics.length < 2) {
        this.$message({
          showClose: true,
          type: "error",
          message: "身份证必须是正反面两张图片"
        });
        return;
      }
      this.$db.post("report-uploadPictures", this.uploadPicParams).then(res => {
        if (res.code == 200) {
          this.$message({
            showClose: true,
            type: "success",
            message: res.msg
          });
          this.uploadPicParams = {
            cardno_pics: [],
            poor_pics: [],
            settlement_pics: []
          }; // 保存成功则清空已选择的图片和勾选的用户id
          this.init(); // 刷新页面
          this.modal1 = false; // 关闭弹窗
          this.$refs.imgUploadPic1.clearFiles();
          this.$refs.imgUploadPic2.clearFiles();
          this.$refs.imgUploadPic3.clearFiles(); // 清空已上传文件列表
        } else {
          this.$message({
            showClose: true,
            type: "error",
            message: res.msg
          });
        }
      });
    },
    openImg (type) {
      if (type == 1) {
        // 发票样板
        this.modalImg1 = true;
      } else {
        // 费用清单样板
        this.modalImg2 = true;
      }
    },
    onExceed (file, fileList) {
      this.$message.error("身份证只能是正反面两张图片");
    }
  },
  created () {
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.init();
    this.getEasyList();
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    // max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
}
.tishi {
  color: red;
  display: block;
  position: absolute;
  top: 42px;
  left: 32%;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/Report/list.vue